import Iconify from '@syntra/ui/components/iconify';

import { paths } from 'src/routes/paths';

// ----------------------------------------------------------------------

export const navConfig = [
  {
    title: 'Home',
    icon: <Iconify icon="solar:home-2-bold-duotone" />,
    path: '/',
  },
  {
    title: 'Need help?',
    icon: <Iconify icon="solar:notebook-bold-duotone" />,
    path: paths.help,
  },
];
